import { EXPERIMENTS } from '../../shared/utils/experiments';
import { LocaleCode, type LocaleCodeValue } from '../../../base/shared/utils/locales';

type UpsellVariant = 'control' | 'A' | 'a';

interface UpsellExperiment {
  name: string
  activeVariant: UpsellVariant
  locales: readonly LocaleCodeValue[]
}

function getUpsellExperiments(): UpsellExperiment[] {
  return [
    { name: EXPERIMENTS.UPSELL_111, activeVariant: 'A', locales: [LocaleCode.EN] },
    { name: EXPERIMENTS.UPSELL_WW, activeVariant: 'a', locales: [LocaleCode.EN] },
    { name: EXPERIMENTS.UPSELL_LAT_AM, activeVariant: 'a', locales: [LocaleCode.EN, LocaleCode.ES_MX] },
  ];
}

export function useUpsellExperiment() {
  const { getVariation } = useGrowthBook();

  const activeExperiment = computed(() => getUpsellExperiments().find(
    ({ name, activeVariant }) => getVariation<UpsellVariant>(name, 'control') === activeVariant,
  ));

  const hasNewUpsellPlans = computed(() => Boolean(activeExperiment.value));

  function isNewUpsellsFlow(locale: string): boolean {
    return activeExperiment.value?.locales.includes(locale as LocaleCodeValue) ?? false;
  }

  return {
    hasNewUpsellPlans,
    isNewUpsellsFlow,
  };
}
